<template>
    <div>
        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
            <span>External Email <i v-if="loading" class="fa fa-refresh fa-spin"></i></span>
            <div class="pull-right hidden md:inline">
                <button class="btn btn-sm btn-dark shadow-none" type="button" @click="getData();getContactSequences()">
                    <i class="fa fa-refresh"></i> Refresh
                </button>
                <button class="btn btn-sm btn-light shadow-none" type="button" @click="composing=true" :disabled="!canEdit">
                    <i class="fa fa-envelope"></i> Compose Email
                </button>
            </div>
            <button class="border-teal bg-white font-semibold p-1 rounded-full text-teal ml-1 md:hidden pull-right"
                    id="externalEmailOptionsDropdown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-caret-down mx-2"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="externalEmailOptionsDropdown">
                <button @click.prevent="getData" class="dropdown-item">
                    Refresh
                </button>
                <button @click.prevent="composing=true" class="dropdown-item">
                    Compose Email
                </button>
            </div>
        </div>

        <div class="flex justify-center my-3" v-if="error">
            <div class="alert alert-danger -mb-6" role="alert">
               <span class="hidden lg:inline">
                   Please go to your <a href="/settings">settings</a>, and disconnect your email under the External Email area. Then, reconnect your email.
                </span>
            </div>
        </div>

        <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch w-full">
            <div class="w-full lg:w-1/2 p-2">
                <table class="text-left w-full border-collapse">
                    <thead class="bg-teal">
                    <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light text-center hidden md:table-cell">
                        <i class="fa fa-paperclip"></i>
                    </th>
                    <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light">
                        Subject
                    </th>
                    <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light">
                        From
                    </th>
                    <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light text-center hidden md:table-cell">
                        <i class="fa fa-exclamation"></i>
                    </th>
                    <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light hidden md:table-cell">
                        Date
                    </th>
                    </thead>
                    <tbody v-if="allEmails.length > 0">
                    <tr v-for="email in allEmails" :key="email.id" class="cursor-pointer" @click="loadEmailBody(email)" :class="(active_email && active_email !== undefined && active_email.id === email.id) ? 'active-email-style' : ''">
                        <td class="py-3 px-6 border-b border-grey-light text-xs text-center hidden md:table-cell">
                            <i class="fa fa-paperclip" v-if="email.hasAttachments && !email.attachmentLoading" @click="downloadAttachments(email)"></i>
                            <i v-if="email.hasAttachments && email.attachmentLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                        </td>
                        <td class="pl-2 py-3 border-b border-grey-light text-xs">
                            {{ formattedSubject(email.subject) }}
                            <i class="fa fa-eye" v-if="email.isRead" style="color: #0a8c62"></i>
                            <i class="fa fa-eye-slash" v-if="email.isRead===false" style="color: grey"></i>
                        </td>
                        <td class="pl-2 py-3 border-b border-grey-light text-xs" style="word-break: break-all">
                            <div>{{ email.from_email }}</div>
                        </td>
                        <td class="py-3 px-6 border-b border-grey-light text-xs text-center hidden md:table-cell">
                            <div v-if="email.importance === 'high'">
                                <i class="fa fa-exclamation text-red"></i>
                            </div>
                        </td>
                        <td class="pl-2 py-3 border-b border-grey-light text-xs hidden md:table-cell" :class="{'sequence-background' : email.is_sequence}">
                            {{ email.sending_time }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="hidden lg:flex border-1 border-grey mr-4"></div>
            <div class="w-full lg:w-1/2">
                <hr class="lg:hidden">
                <div v-if="composing" style="height: 450px;overflow: scroll;width: 100%;">
                    <div class="inline-block flex-wrap w-100 overflow-hidden">
                        <div class="w-1/2 lg:my-2 w-full">
                            <div class="w-full mt-2 mt-lg-0">
                                <div class="pt-3 text-right mr-1">
                                    <span v-if="hasSequencesAccess">
                                        <b-button
                                            v-if="showStopButton"
                                            class="bg-primary template-button ml-2"
                                            pill
                                            variant="info"
                                            @click.stop.prevent="stopEmailSequence"
                                        >Stop Sequence</b-button>
                                        <b-button
                                            class="bg-primary template-button ml-2"
                                            pill
                                            variant="info"
                                            type="button"
                                            @click.stop.prevent="openEmailSequenceModal"
                                        >Sequences</b-button>
                                    </span>
                                    <b-button
                                        class="bg-primary template-button ml-2"
                                        pill
                                        variant="info"
                                        @click.stop.prevent="openEmailTemplateModal"
                                    >Templates</b-button>
                                </div>
                                <div>
                                    <label for="to"
                                           :class="{'text-red' : errors.to}"
                                    >To (example@email.com)</label>
                                </div>
                                <div class="row mx-0 w-full md:w-auto self-center">
                                    <input class="form-control col-md-9"
                                           :class="errors.to ? 'is-invalid' : null"
                                           @input="() => errors.to = null"
                                           type="text" name="to" id="mail_to" v-model="emailForm.to">
                                    <button class="form-control btn btn-primary col-md-2 md:ml-1 md:mr-1"
                                            @click.prevent.stop="openNewModal('to')">
                                        <i class="fa fa-user-circle-o"></i>
                                    </button>
                                </div>
                                <small v-if="errors.to" class="text-danger">
                                    {{ errors.to }}
                                </small>
                            </div>
                        </div>
                        <div class="lg:my-2 w-full mt-2 mt-lg-0">
                            <div>
                                <div>
                                    <label for="cc"
                                           :class="{'text-red' : errors.cc}"
                                    >CC (examplecc@mail.com)</label>
                                </div>
                                <div class="row mx-0 w-full md:w-auto self-center">
                                    <input class="form-control col-md-9" :class="errors.cc ? 'is-invalid' : null"
                                           type="text" name="cc" id="mail_cc" v-model="emailForm.cc">
                                    <button class="form-control btn btn-primary col-md-2 md:ml-1"
                                            @click.stop.prevent="openNewModal('cc')">
                                        <i class="fa fa-user-circle-o"></i>
                                    </button>
                                </div>
                                <small v-if="errors.cc" class="text-danger">
                                    {{ errors.cc }}
                                </small>
                            </div>
                        </div>
                        <div class="w-full mt-2 mt-lg-0">
                            <b-form-group
                                label="Subject"
                                label-for="subject"
                                :invalid-feedback="errors.subject"
                                :state="!errors.subject"
                            >
                                <b-input-group
                                    :append="subjectSufix()"
                                >
                                    <b-form-input
                                        id="subject"
                                        v-model="emailForm.subject"
                                        :state="!errors.subject ? null : false"
                                        @input="()=>errors.subject = null"
                                        trim
                                    />
                                </b-input-group>
                            </b-form-group>

                        </div>
                        <div class="w-full lg:mb-2 mt-2">
<!--                            <textarea class="form-control" cols="20" rows="8"
                                      :class="errors.body ? 'is-invalid' : null"
                                      @input="() => errors.body = null"
                                      type="text" name="body" id="mail_body" v-model="emailForm.body"></textarea>-->
                        <ckeditor-container-email  :class="errors.body ? 'is-invalid' : null" @mention="addMention" :options="[]"
                                                 @input="() => errors.body = null" id="comment" v-model="emailForm.body"
                                                 mentionFrom="name"></ckeditor-container-email>
<!--                            <vue-text-editor :text-binding="emailForm.body" :class="errors.body ? 'is-invalid' : null"-->
<!--                                             @input="() => errors.body = null" v-on:emailBodyText="emailBodyText"></vue-text-editor>-->
                            <small v-if="errors.body" class="text-danger">
                                {{ errors.body }}
                            </small>
                        </div>
                        <div class="lg:my-2 w-full mt-2 mt-lg-0">
                            <label for="email-file-attachment" class="mt-1 mb-1" :class="{'text-red' : errors.file}">
                                Files
                            </label>
                            <div class="row mx-0 w-full md:w-auto self-center mb-1">
                                <label v-if="uploadFiles.length == 0" for="email-file-attachment" class="cursor-pointer w-full border-1 bg-grey-lightest p-3 text-center" @dragover="dragover" @dragleave="dragleave" @drop="drop" id="dropContainer">
                                    <i class="fa fa-upload fa-2x mb-4" aria-hidden="true"></i>
                                    <br>
                                    <span class="text-black text-lg">
                                            Click or drag to upload file
                                        </span>
                                    <br>
                                    <span class="text-grey-dark text-sm">
                                            Support for a single or bulk upload
                                        </span>
                                </label>
                                <div v-else class="w-full border-1 bg-white px-2 py-1 text-left mb-2" @dragover="dragover" @dragleave="dragleave" @drop="drop" id="dropList">
                                    <div class="row p-0 m-0 text-sm text-truncate pb-1 pt-1" :class="(index == uploadFiles.length-1)? 'border-b-0':'border-b-1'" v-if="uploadFiles.length > 0" v-for="(uploadFile, index) in uploadFiles">
                                        <div class="col-11 p-0 m-0">
                                            {{ uploadFile.name }}
                                        </div>
                                        <div class="col-1 text-right">
                                            <i class="fa fa-trash-o cursor-pointer text-red" @click="removeFromUploadFile(uploadFile, index)" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group cursor-pointer rounded-sm p-2 text-grey-darkest text-sm border-1 field-height-update w-full email-file-attachment-class">
                                    <label class="input-group-text rounded-none" for="email-file-attachment">Select files</label>
                                    <label tabindex="0" class="form-control">
                                        {{(uploadFiles.length == 0) ? 'Click here to Select file(s)' : (uploadFiles.length == 1) ? '1 file is selected'  : uploadFiles.length +' files are selected' }}
                                        <input type="file" class="invisible" ref="file" id="email-file-attachment" @change="attach($event)" name="attach" multiple>
                                    </label>
                                </div>
                            </div>
                            <small v-if="errors.file" class="text-danger">
                                {{ errors.file }}
                            </small>
                        </div>
                        <div class="lg:my-2 w-full mt-2 mt-lg-0">
                            <label for="to" class="mt-1 mb-1" :class="{'text-red' : errors.to}">
                                Priority
                            </label>
                            <div class="row mx-0 w-full md:w-auto self-center">
                                <select class="cursor-pointer rounded-sm p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update w-full" v-model="emailForm.importance">
                                    <option value="low">Low</option>
                                    <option value="normal">Normal</option>
                                    <option value="high">High</option>
                                </select>
                            </div>
                            <small v-if="errors.cc" class="text-danger">
                                {{ errors.cc }}
                            </small>
                        </div>
                        <div class="w-full">
                            <div class="row mx-0 lg:ml-3 mt-2">
<!--                                <input type="file" @change="attach($event)" name="attach"-->
<!--                                       class="btn btn-primary col-12 col-md-6 md:pr-1 col-lg-6 col-xl-3 mt-2 mt-lg-0">-->
<!--                                <select class="form-control col-12 col-md-6 col-xl-3 xl:pr-1 mt-2 mt-lg-0"-->
<!--                                        v-model="emailForm.importance">-->
<!--                                    <option value="low">Low</option>-->
<!--                                    <option value="normal">Normal</option>-->
<!--                                    <option value="high">High</option>-->
<!--                                </select>-->
                                <button class="btn btn-primary mt-2 mt-lg-0 pr-1 col-6 col-xl-4 xl:mt-1 mr-1"
                                        @click.prevent="send" :disabled="isSendEmailBtnDisabled">
                                    <i class="fa fa-paper-plane-o mr-2"></i>{{ sendEmailBtnText }}
                                </button>
                                <button class="btn btn-secondary mt-2 mt-lg-0 col-6 col-xl-4 xl:mt-1"
                                        @click.prevent="composing = false">
                                    <i class="fa fa-times-circle-o mr-2"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_email && !composing">
                    <div class="flex w-full items-start mb-3">
                        <div class="hidden md:flex">
                            <i class="fa fa-3x fa-user-circle-o mr-2"></i>
                        </div>
                        <div>
                            <p><span class="md:hidden">From </span>{{ active_email.from_email }}</p>
                            <p class="text-grey">
                                To {{active_email.to_email}}
                            </p>
                        </div>
                    </div>
                    <div class="max-email-height">
                        <div v-html="active_email.body" class=""></div>
                    </div>
                </div>
                <div v-if="!composing && !active_email" class="my-5">
                    <div class="alert alert-primary" role="alert">
                        Click "Compose Email" to start a new email, or on email from to list to read it
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" id="exampleModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12" style="text-align: center; font-size:20px; margin-top: 10px;">Add Emails</div>
                            <div class="col-md-12" style="text-align: center; margin-top: 32px;">
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                        @click="openNewCompanyContactModal"> Company Contacts</button>
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;"
                                        @click="openEmailContactModal">Email Contacts</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <email-contacts-modal ref="EmailContactModal" :exchange="exchange" v-on:set-emails="setEmails"></email-contacts-modal>
        <company-contacts-modal ref="CompanyContactsModal" :exchange="exchange" v-on:set-emails="setEmails"></company-contacts-modal>
        <email-template-modal ref="EmailTemplateModal" v-on:addTemplateToEmail="addTemplateToEmail"></email-template-modal>
        <sequence-modal ref="EmailSequenceModal" :project="project" v-on:addSequenceToContactEmail="addSequenceToContactEmail" :selectedContactForSequence="contact" :allFields="allFields" :subSuffix="subSuffix" ></sequence-modal>


        <div class="modal fade" id="emailAttachmentsModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">Email Attachments</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="downloadingAttachmentFiles.length > 0" v-for="attachment in downloadingAttachmentFiles">
                                <td>{{ attachment.name }}</td>
                                <td><button @click="downloadFile(attachment.path, attachment.name)" class="btn btn-primary">Download File</button></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import CkeditorContainer from "../shared/ckeditor-container.vue";
import CkeditorContainerEmail from "../shared/ckeditor-container-email.vue";

export default {
    name: "contact-external-email-section",
    components: {CkeditorContainerEmail, CkeditorContainer},
    props: ['project', 'email','contact','canEdit', 'hasSequencesAccess','exchange', 'company'],

    data() {
        return {
            emails: [],
            contactEmails: [],
            composing: false,
            active_email: null,
            type:'',
            emailForm: {
                to: '',
                cc: '',
                subject: ``,
                attachment: [],
                body: '',
                importance: 'low',
            },
            errors: {
                to: null,
                subject: null,
                body: null
            },
            loading: false,
            error: false,
            allFields: [
                {
                    "optionTypes": "Project Fields",
                    "optionValues": [
                        {
                            id: 0,
                            button: 'addYourName',
                            text: 'My Name',
                            buttonCode: 'replaceYourName'
                        },
                        {
                            id: 1,
                            button: 'addName',
                            text: 'Name',
                            buttonCode: 'replaceName'
                        },
                        {
                            id: 2,
                            button: 'addPhone',
                            text: 'Phone',
                            buttonCode: 'replacePhone'
                        },
                        {
                            id: 3,
                            button: 'addEmail',
                            text: 'Email',
                            buttonCode: 'replaceEmail'
                        },
                        {
                            id: 4,
                            button: 'addCompanyName',
                            text: 'Company Name',
                            buttonCode: 'replaceCompanyName'
                        },
                        {
                            id: 5,
                            button: 'addTitle',
                            text: 'Title',
                            buttonCode: 'replaceTitle'
                        },
                        {
                            id: 6,
                            button: 'addType',
                            text: 'Type',
                            buttonCode: 'replaceType'
                        },
                        {
                            id: 7,
                            button: 'addFollowUp',
                            text: 'Follow Up',
                            buttonCode: 'replaceFollowUp'
                        },
                        {
                            id: 8,
                            button: 'addLastUpdated',
                            text: 'Last Updated',
                            buttonCode: 'replaceLastUpdated'
                        }
                    ]}

            ],
            showStopButton: false,
            sendEmailBtnText: 'Submit',
            isSendEmailBtnDisabled: false,
            uploadFiles: [],
            downloadingAttachmentFiles: [],
        }
    },
    watch: {
        composing(value) {
            if (value) this.emailForm.to = this.email;
        },
        // 'emailForm.to': function(newValue,oldToValue) {
        //     this.removeSpacesTo();
        // },
        // 'emailForm.cc': function(newValue,oldToValue) {
        //     this.removeSpacesCc();
        // }
    },
    created() {
        this.getData();
        this.getContactSequences();
    },
    mounted() {
        this.emails.forEach(function (email) {
            email.receivedDateTime = moment(email.receivedDateTime).format('L LT');
        });

        Bus.$on('openContactModalEmail', data => {
            this.$refs.CompanyContactsModal.close();
            this.$refs.EmailContactModal.open(data);

        });
        Bus.$on('openCompanyContactModalEmail', data => {
            this.$refs.EmailContactModal.close();
            this.$refs.CompanyContactsModal.open(data);

        });
    },

    methods: {
        openNewModal(type){
            $('#exampleModal').modal('show');
            this.type = type;
        },
        removeSpacesTo() {
            this.emailForm.to = this.emailForm.to.replace(/\s/g, '');
        },
        removeSpacesCc() {
            this.emailForm.cc = this.emailForm.cc.replace(/\s/g, '');
        },
        getData() {
            this.loading = true;
            axios.get(route('external-email.emails') + '?contact_id=' + this.contact.id)
                .then((data) => {

                    if (data.data.error) {
                        this.loading = false;
                        this.error = true;
                        return;
                    }

                    this.emails = data.data;
                    this.emails = this.emails.map(email => {
                        let recipients = '';
                        email.toRecipients.map(x => {
                            recipients = recipients +','+x.emailAddress.address
                        });

                        return {
                            id: email.id,
                            importance: email.importance,
                            subject: email.subject,
                            body: email.body.content,
                            from_email: email.sender.emailAddress.name,
                            to_email: recipients.replace(/^,/, ''),
                            hasAttachments: email.hasAttachments,
                            sending_time: moment(email.receivedDateTime).format('L LT'),
                            is_sequence: 0,
                            isRead: email.isRead ?? '',
                            attachments: email.attachments,
                            attachmentLoading: false
                        }
                    });

                    this.$emit('refresh-comments');
                    this.loading =  false;
                })
                .catch(error => {
                    this.loading = false;
                    this.emails = [];
                });
        },

        getContactSequences() {
            this.showStopButton = false;
            if(this.hasSequencesAccess){
                this.loading = true;
                axios.get(route('api.sequence.get-contact-sequences') + '?contact_id=' + this.contact.id)
                    .then(({data}) => {
                        if(data.data.length > 0){
                            this.showStopButton = true;
                        }
                        this.contactEmails = data.data.map(x=>({...x, sending_time: moment(x.sending_time).format('L LT')}));
                        this.contactEmails = this.contactEmails.sort(function (left, right) {
                            return moment.utc(right.sending_time).diff(moment.utc(left.sending_time))
                        });
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        this.contactEmails = [];
                    });
            }else{
                this.loading = false;
            }
        },

        send() {
            let self = this;
            self.isSendEmailBtnDisabled = true;
            this.clearEmailErrors();
            self.sendEmailBtnText = 'Sending...';

            const data = new FormData();
            // data.append('attachment', this.emailForm.attachment);
            for (let i = 0; i<this.emailForm.attachment.length; i++){
                data.append('attachment[' + i + ']', this.emailForm.attachment[i]);
            }
            data.append('cc', this.processEmails(this.emailForm.cc));
            data.append('to', this.processEmails(this.emailForm.to));
            data.append('subject', this.emailForm.subject);
            data.append('body', this.emailForm.body);
            data.append('importance', this.emailForm.importance);
            data.append('project_id', null);
            data.append('contact_id', this.contact.id);

            axios.post(route('external-email.send'), data)
                .then(
                    (data) => {
                        self.isSendEmailBtnDisabled = false;
                        self.sendEmailBtnText = 'Submit';
                        self.composing = false;
                        self.getToast().fire({
                            type: 'success',
                            title: 'Your Email Has Been Sent'
                        });
                        self.getData();
                        self.getContactSequences();
                        self.clearEmailForm();
                        // window.location.reload();
                    }
                )
                .catch(
                    (err) => {
                        self.isSendEmailBtnDisabled = false;
                        self.sendEmailBtnText = 'Submit';
                        for (let key in err.response.data.errors) {
                            this.errors[key] = err.response.data.errors[key][0];
                        }

                        if (err.response.status !== 422) {
                            Swal.fire({
                                title: 'Submit Error',
                                text: 'The email could not be sent. Please check if the recipient emails are valid and if you are connected to an external email.',
                                type: 'error',
                                closeOnConfirm: true,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'OK!',
                            });
                        }
                    }
                )
        },
        processEmails(emails) {
            const emailArray = emails.split(";");
            const cleanedEmailArray = emailArray.map(email => email.trim());
            return  cleanedEmailArray.join(";");
        },
        toDate(date) {
            return moment(date).format("MM/DD/YYYY")
        },

        loadEmailBody(email) {
            this.active_email = email
            this.composing = false;
        },
        openEmailContactModal(type) {
            $('#exampleModal').modal('hide');
            this.$refs.EmailContactModal.open(this.type);
        },
        openNewCompanyContactModal() {
            $('#exampleModal').modal('hide');
            this.$refs.CompanyContactsModal.open(this.type);
        },
        openContactEmailModal(type) {
            this.$refs.EmailContactModal.open(type);
        },

        setEmails(part) {
            if(part[1] === 'cc') {
                let emailsCC = this.emailForm.cc;
                if (!emailsCC.endsWith(";") && this.emailForm.cc !== '') {
                    this.emailForm.cc = emailsCC + ";";
                } else {
                    this.emailForm.cc = emailsCC;
                }
                return this.emailForm.cc = this.emailForm.cc + part[0].join(";");
            }
            let emailsTo = this.emailForm.to;
            if (!emailsTo.endsWith(";") && this.emailForm.to !== '') {
                this.emailForm.to = emailsTo + ";";
            } else {
                this.emailForm.to = emailsTo;
            }
            return this.emailForm.to = this.emailForm.to + part[0].join(";");
        },

        attach(event) {
            let files = _.union(this.uploadFiles, Object.values(event.target.files));
            if (files.length > 5){
                this.getToast().fire({
                    type: 'error',
                    title: 'Maximum file selection limit reached: Please select up to 5 files only.'
                });
            }else {
                this.uploadFiles = files;
                this.emailForm.attachment = this.uploadFiles;
            }
        },

        formattedSubject(subject) {
            return subject === this.subjectSufix() ? this.subjectSufix() : subject.replace(this.subjectSufix(), "");
        },

        subjectSufix() {
            return `(${this.contact.name} - ${this.contact.id})`;
        },

        clearEmailErrors() {
            for (let key in this.errors) {
                this.errors[key] = null
            }
        },

        clearEmailForm() {
            this.uploadFiles = [];
            this.emailForm.attachment = null
            this.emailForm.cc = ''
            this.emailForm.to = ''
            this.emailForm.subject = ''
            this.emailForm.body = ''
            this.emailForm.importance = 'low'
        },

        openEmailTemplateModal(){
            this.$refs.EmailTemplateModal.open(true);
        },
        openEmailSequenceModal(){
            this.$refs.EmailSequenceModal.open(true);
        },
        addTemplateToEmail(template){
            this.emailForm.body = template.template_text;
        },
        emailBodyText(val){
            this.emailForm.body = val;
        },
        addSequenceToContactEmail(sequence){
            const data = {
                sequence_id: sequence.id,
                contact_id: this.contact.id
            };

            axios.post(route('api.sequence.apply-contact-sequence'), data)
                .then(
                    ({data}) => {
                        if(data.status) {
                            this.getToast().fire({
                                type: 'success',
                                title: data.message
                            })
                            this.getData()
                            this.getContactSequences()
                        }else{
                            this.getToast().fire({
                                type: 'error',
                                title: data.message
                            })
                        }
                    }
                )
                .catch(
                    (err) => {
                        console.log(err)
                    }
                )
        },
        stopEmailSequence() {
            axios.post(route('api.sequence.stop-contact-sequence'), {contact_id: this.contact.id})
                .then(
                    ({data}) => {
                        if(data.status) {
                            this.showStopButton = false;
                            this.getToast().fire({
                                type: 'success',
                                title: data.message
                            })
                            this.getData()
                            this.getContactSequences()
                        }else{
                            this.showStopButton = true;
                            this.getToast().fire({
                                type: 'error',
                                title: data.message
                            })
                        }
                    }
                )
                .catch(
                    (err) => {
                        console.log(err)
                    }
                )
        },
        downloadAttachments(email) {
            email.attachmentLoading = true;
            axios.post(route('external-email.attachment-download'), {attachments: email.attachments, companyId: this.company.id})
                .then((data) => {
                    email.attachmentLoading = false;
                    this.getToast(3000).fire({
                        type: 'success',
                        title: 'Attachments successfully synced to Followupcrm'
                    });
                    if(data.data.path.length > 0){
                        this.downloadingAttachmentFiles = data.data.path
                        $('#emailAttachmentsModal').modal('show');
                    }else{
                        this.getToast(3000).fire({
                            type: 'error',
                            title: 'Error occurred while downloading attachments.',
                        });
                    }
                })
                .catch((err) => {
                    email.attachmentLoading = false;
                    console.log(err);
                })
        },
        removeFromUploadFile(uploadFile, index){
            this.uploadFiles.splice(index, 1);
            this.emailForm.attachment = this.uploadFiles;
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.uploadFiles = [...this.$refs.file.files, ...this.uploadFiles];
            this.emailForm.attachment = this.uploadFiles;
        },
        addMention(){

        },
        downloadFile(fileUrl, fileName) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.target = '_blank';
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
    computed: {
        subSuffix(){
            return `(${this.contact.name} - ${this.contact.id})`;
        },
        allEmails(){
            return this.emails.concat(this.contactEmails);
        },
    }

}
</script>

<style lang="css">
.max-email-height {
    max-height: 500px;
    overflow: auto;
}
.sequence-background{
    background: #FFFD78;
}
.cke_editable .projectDataHidden{
    display: none;
}
.bv-no-focus-ring .input-group #subject {
    border: 1px solid #a7acb6;
    padding: unset;
}

#wsc_img_banner {
    display: none !important;
}
</style>

